import React from "react";
import { Modal } from "react-bootstrap";
import { SubscriptionIcon } from "../../../../util/Icons";
import { BillingDetails } from "./components/BillingDetails";

const ViewBillingModal = ({ showViewBillingModal, details, onHide }) => {
    return (
        <Modal
            show={showViewBillingModal}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SubscriptionIcon />
                    </span>
                    Billing Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 pt-2 pb-10"
            >
                <BillingDetails details={details}/>
            </Modal.Body>
        </Modal>

    );
}

export default ViewBillingModal;